const SetBarsPosition = ($window, $header, $bars) => {
  const $headerHeight = $header.getBoundingClientRect().height

  if ($window.pageYOffset >= $headerHeight && $window.innerWidth >= 1024)  {
    $bars.forEach(($bar) => {
      $bar.classList.add('--followme')
    })

    return
  }

  $bars.forEach(($bar) => {
    $bar.classList.remove('--followme')
  })
}

const FollowmeBars = () => {
  const $header = document.querySelector('header')
  const $follwmeBars = document.querySelectorAll('[followme-bar]')

  if (!$follwmeBars.length > 0) return

  SetBarsPosition(window, $header, $follwmeBars)

  window.addEventListener('scroll', (e) => {
    SetBarsPosition(window, $header, $follwmeBars)
  })
}

export default FollowmeBars
